import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { DetailedEventViewModel } from './event-details-common.models';

@Injectable({ providedIn: 'root' })
export class EventDetailsViewModelService {
    private _detailedEventViewModel$ = new BehaviorSubject<DetailedEventViewModel | undefined>(undefined);
    readonly detailedEventViewModel$ = this._detailedEventViewModel$.asObservable();

    setDetailedEventViewModel(viewModel: DetailedEventViewModel): void {
        this._detailedEventViewModel$.next(viewModel);
    }
}
